<!--suppress ALL -->
<template>
	<v-select clearable :items="options" v-model="model" :label="label" item-text="title" item-value="id"></v-select>
</template>

<script>
	import LotteryModule from "src/store/modules/Lottery.module";
	import SelectMixin from "src/mixins/SelectMixin";

	export default {
		name: "lotteries-select",
		mixins: [new SelectMixin(LotteryModule, "lotteries")],
		props: {value: {default: null},label:String},
		components: {}
	};
</script>
